import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from 'src/app/services/toasts.service';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-excel-export-modal',
    templateUrl: './excel-export-modal.component.html',
    styleUrl: './excel-export-modal.component.scss',
    imports: [FormsModule]
})
export class ExcelExportModalComponent {
  limitDepthByDOS: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private toastService: ToastService,
    private planogramApiService: PlanogramApiService
  ) {}

  confirm(): void {
    let message = `Exporting planogram Excel`;
    this.toastService.show(message, { classname: `bg-dark text-light p-3 fs-5`, delay: 5000 });

    let additionalData: any = {
      limitDepthByDOS: this.limitDepthByDOS ? "true" : "false"
    };

    this.planogramApiService.exportPlanogram(1, 'Excel', additionalData);
    this.activeModal.close(null);
  }

  cancel(): void {
    this.activeModal.close(null);
  }
}